import { put } from 'redux-saga/effects';
import { fetchAlfaKodeOversikt } from '../../felles/APICalls_NV06';
import * as actions from '../actions';
import * as actionsNV06 from '../actions/indexNV06';

export function* fetchAlfaOversiktSaga(action: any): Generator<any, void, any> {
  try {
    yield put(actions.setIsloading(true));
    const { companyId, page, pageSize, search, sortBy, sortDirection } = action.payload;

    const response = yield fetchAlfaKodeOversikt(companyId, page, pageSize, search, sortBy, sortDirection);

    if (response && response.data) {
      yield put(actionsNV06.fetchAlfaOversiktSuccess(response.data));
    } else {
      yield put(actionsNV06.fetchAlfaOversiktFailure('Ingen data mottatt'));
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || error?.message || 'Ukjent feil';
    yield put(actionsNV06.fetchAlfaOversiktFailure(errorMessage));
  } finally {
    yield put(actions.setIsloading(false));
  }
}
